import React from "react";
import { Layers, Hammer, AppWindow, DoorOpen, PaintRoller, Droplet, ArrowRight, Trees } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Professional Landscaping",
  description: "Expert lawn care and garden design to keep your property's exterior pristine and inviting.",
  icon: Trees
}, {
  title: "Interior & Exterior Painting",
  description: "Premium painting services with high-quality finishes that protect and beautify your property.",
  icon: PaintRoller
}, {
  title: "High-Pressure Washing",
  description: "Restore your surfaces with deep cleaning that removes years of dirt and stubborn grime.",
  icon: Droplet
}, {
  title: "Comprehensive Janitorial",
  description: "Meticulous cleaning services designed to maintain a healthy and sparkling environment for all.",
  icon: DoorOpen
}, {
  title: "Facility Maintenance",
  description: "Your reliable one-stop shop for all property repairs, ensuring your facility remains in peak condition.",
  icon: Hammer
}, {
  title: "Project Showcase",
  description: "Explore our gallery of completed projects demonstrating our commitment to top-tier craftsmanship.",
  icon: AppWindow
}];
export default function ExteriorMastery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="4287" id="the-one-stop-maintenance-shop" className="bg-background text-foreground py-40 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={ref} className={`flex items-center gap-6 mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="w-1.5 h-16 bg-primary shrink-0 rounded-full shadow-[0_0_20px_var(--primary-500)/30]" />
          <div>
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter text-foreground uppercase">
              The One-Stop Maintenance Shop
            </h2>
            <p className="text-muted-foreground mt-2 text-lg md:text-xl max-w-2xl font-medium">
              Premium facility maintenance and property care solutions for residential and commercial clients.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <Card className="h-full bg-card/60 backdrop-blur-md border-border hover:border-primary/50 hover:bg-gradient-to-br hover:from-background hover:to-accent/5 transition-all duration-500 flex flex-col justify-between group shadow-[0_15px_35px_rgba(0,80,150,0.05)] hover:shadow-[0_20px_45px_rgba(0,80,150,0.1)] rounded-3xl">
                  <CardHeader className="pb-2">
                    <div className="mb-6">
                      <Icon className="w-14 h-14 text-primary transition-transform duration-500 group-hover:scale-110" strokeWidth={1.25} />
                    </div>
                    <CardTitle className="text-2xl font-extrabold leading-tight tracking-tight text-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pb-6">
                    <p className="text-muted-foreground leading-relaxed line-clamp-3">
                      {service.description}
                    </p>
                  </CardContent>
                  <CardFooter>
                    <Link to="/OurServicesPage" className="group/link inline-flex items-center text-primary font-bold text-sm uppercase tracking-widest hover:text-primary/80 transition-colors">
                      Explore Service
                      <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-2" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}